(function () {

    'use strict';

    angular.module('iplusjs.validator.kfzKennzeichen', [
        'lodash',
        'iplusjs.utils.misc',
        'iplusjs.fieldset'
    ])
        .directive('iplusjsKfzKennzeichenValidator', kfzKennzeichenValidator);

    kfzKennzeichenValidator.$inject = [
        '$q',
        '$log',
        'lodash',
        'MiscUtilsService'
    ];
    function kfzKennzeichenValidator($q, $log, _, MiscUtilsService) {
        return {
            require: ['ngModel', '^?iplusjsFieldset'],
            link: linkFnc
        };

        function linkFnc($scope, $elem, $attrs, ctrls) {
            var $ngModel = ctrls[0],
                fieldsetCtrl = ctrls[1],
                kfzKennzeichenType = $attrs.iplusjsKfzKennzeichenValidator || 'icisPkw',
                regexKennzeichen = {
                    icisPkw: /^(?=.{2,12}$)([A-ZÄÜÖ]{1,3})-(([A-Z]{1,2}\s[0-9]{1,4})?|[0-9]{1,5}|OHNE)?[HVE]?$/,
                    icisMoped: /^((?=.{7}$)([A-Z]{3})\.([0-9]{3}))|((?=.{7}$)([0-9]{3})\.([A-Z]{3}))$/,
                    icisPkwMoped: /(^(?=.{2,12}$)([A-ZÄÜÖ]{1,3})-(([A-Z]{1,2}\s[0-9]{1,4})?|[0-9]{1,5}|OHNE)?[HVE]?$)|(^((?=.{7}$)([A-Z]{3})\.([0-9]{3}))|((?=.{7}$)([0-9]{3})\.([A-Z]{3}))$)/
                };

            if ($attrs.disabled || $scope.$eval($attrs.ngDisabled) || (fieldsetCtrl && fieldsetCtrl.disabled)) {
                return;
            }

            $scope.$watch(function () {
                return $attrs.iplusjsKfzKennzeichenValidator;
            }, function (newValue) {
                if (newValue) {
                    kfzKennzeichenType = $attrs.iplusjsKfzKennzeichenValidator || 'icisPkw';
                    $ngModel.$validate();
                }
            });
            $ngModel.$validators.kfzKennzeichen = function (value) {
                var validationValue,
                    regex = regexKennzeichen[kfzKennzeichenType];

                validationValue = MiscUtilsService.getValueCustomObject(value || $ngModel.$viewValue);
                if (!validationValue) {
                    return true;
                }

                if (regex) {
                    return regex.test(validationValue);
                }

                return true;
            };
        }
    }
})();
